import React from "react";
import { strings } from "../../Strings";

/**
 * 作業種別ラベルコンポーネント
 * @param {number} value 工事種別ID
 * @param {boolean} textOnly テキスト表示
 * @class WorkTypeLabel
 */
export default function WorkTypeLabel({ value, textOnly = false }) {
  const result = strings.WORK_TYPE_OPTIONS.find((o) => o.value === value);
  return (
    <>
      {result && (
        <>
          {textOnly ? (
            result.label
          ) : (
            <span className={`work-type ${result.className}`}>
              {result.label}
            </span>
          )}
        </>
      )}
    </>
  );
}
